import React from "react";

import { AuthState, useAuth } from '../hooks/auth'
import AppRoutes from './AppRoutes';
import AuthRoutes from "./AuthRoutes";

const Routes: React.FC = () => {
    const { user, setData } = useAuth();
    const expiresAt = localStorage.getItem('@Portal:tokenExpiresAt');

    const setUserInformation = () => {
        if (expiresAt && (new Date(JSON.parse(expiresAt)) < new Date())) {
            setData({} as AuthState);
        }
    }

    if (user && expiresAt && (new Date(JSON.parse(expiresAt)) >= new Date())) {
        return <AppRoutes />
    } else {
        localStorage.removeItem('@Portal:token');
        localStorage.removeItem('@Portal:user');
        localStorage.removeItem('@Portal:profile');
        localStorage.removeItem('@Portal:tokenExpiresAt');

        setUserInformation();

        window.history.replaceState(
            { additionalInformation: 'Updated the URL to Home' },
            'Portal de jogos | A Recreativa',
            '/'
        );

        return <AuthRoutes />
    }
}

export default Routes;